export const omitDeep = (obj, property) => {
    return JSON.parse(JSON.stringify(obj), (key, value) => (key === property ? undefined : value));
};
